/**
 * Returns the base API URL from environment variables
 */
export const getApiBaseUrl = (): string => {
  // For debugging

  // PRODUCTION FIX - Always use /api in production to avoid undefined issues
  if (import.meta.env.PROD) {
    return "/api/";
  }

  // Get API URL from env or use default
  let apiUrl = import.meta.env.VITE_API_URL || "/api";

  // Ensure the URL starts with a slash for consistency
  if (!apiUrl.startsWith("/") && !apiUrl.startsWith("http")) {
    apiUrl = `/${apiUrl}`;
  }

  // Ensure the URL ends with a slash for consistency
  if (!apiUrl.endsWith("/")) {
    apiUrl = `${apiUrl}/`;
  }

  return apiUrl;
};

/**
 * Constructs a full API URL by appending the path to the base URL
 * @param path The API path to append (without leading slash)
 * @returns The full API URL
 */
export const getApiUrl = (path: string): string => {
  const baseUrl = getApiBaseUrl();
  // Ensure path doesn't start with a slash if baseUrl ends with one
  const normalizedPath = path.startsWith("/") ? path.substring(1) : path;

  // For debugging
  // console.log("Base URL:", baseUrl);
  // console.log("Normalized Path:", normalizedPath);
  // console.log("Constructed API URL:", `${baseUrl}${normalizedPath}`);

  return `${baseUrl}${normalizedPath}`;
};
